const TxpDataPointNames = {
    // name for datapoint which logs TXP loading end state.
    TXPCardLoading: 'TXPCardLoading',

    //name for datapoint which logs Txp Feedback.
    TXPUserVoice: 'TXP_UserVoice',

    //name for datapoint which logs Txp Error card.
    TXPErrorCard: 'TXPErrorCard',

    //name for datapoint which logs the counterfactual loggings
    TxpExperimentTrigger: 'TxpExperimentTrigger',

    //name for datapoint which logs When a date cant be parsed correctly
    TxpOwaDataError: 'OwaDataError',
};

export default TxpDataPointNames;
